import React, { useState } from 'react';
import { Mail, Send } from 'lucide-react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    role: '',
    email: '',
    status: 'project',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        fullName: '',
        role: '',
        email: '',
        status: 'project',
        message: ''
      });
    }, 3000);
  };

  return (
    <section id="contact" className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <p className="text-sm text-black mb-4 font-semibold tracking-wide">/ Contact Information</p>
          <h2 className="text-5xl md:text-7xl font-bold text-black mb-6">
            Let's get <span className="text-orange-500">started</span>
          </h2>
          <p className="text-base text-black max-w-2xl mx-auto font-medium">
            I would love to hear more about your project or opportunity.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left - Contact Form */}
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-8 md:p-12">
            <h3 className="text-3xl font-bold text-black mb-8">How can I help?</h3>

            {isSubmitted ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Send className="w-8 h-8 text-white" />
                </div>
                <h4 className="text-2xl font-bold text-black mb-2">Thank you!</h4>
                <p className="text-gray-700">Your message has been sent successfully.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-black mb-2">
                    Your Full Name *
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-xl bg-white border border-gray-200 focus:border-orange-500 focus:outline-none transition-colors text-black"
                    placeholder="John Doe"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-black mb-2">
                    Your Role *
                  </label>
                  <input
                    type="text"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-xl bg-white border border-gray-200 focus:border-orange-500 focus:outline-none transition-colors text-black"
                    placeholder="Product Manager"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-black mb-2">
                    Your Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-xl bg-white border border-gray-200 focus:border-orange-500 focus:outline-none transition-colors text-black"
                    placeholder="john@example.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-black mb-2">
                    Your Status? *
                  </label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-xl bg-white border border-gray-200 focus:border-orange-500 focus:outline-none transition-colors text-black"
                  >
                    <option value="project">I have a project</option>
                    <option value="recruiter">I am a recruiter</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-black mb-2">
                    More Info *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={5}
                    className="w-full px-4 py-3 rounded-xl bg-white border border-gray-200 focus:border-orange-500 focus:outline-none transition-colors resize-none text-black"
                    placeholder="Tell me about your project or opportunity..."
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white py-4 rounded-xl font-medium transition-colors duration-300 flex items-center justify-center gap-2"
                >
                  <Send size={20} />
                  Submit
                </button>
              </form>
            )}
          </div>

          {/* Right - Contact Info */}
          <div className="flex flex-col justify-center space-y-8">
            <div>
              <h3 className="text-3xl md:text-4xl font-bold text-black mb-6 leading-tight">
                Ready to work together?
              </h3>
              <p className="text-base text-black leading-relaxed mb-8 font-medium">
                If the work above fits what you need, send me a note. Share the goal, your timeline, and budget range. I'll reply with next steps.
              </p>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="text-xl font-bold text-black mb-1">Email</h4>
                  <a
                    href="mailto:info@jagjotsingh.space"
                    className="text-black hover:text-orange-500 transition-colors font-medium"
                  >
                    info@jagjotsingh.space
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;